import { render, staticRenderFns } from "./WinnersTable.vue?vue&type=template&id=05a3e49e&scoped=true"
import script from "./WinnersTable.vue?vue&type=script&lang=js"
export * from "./WinnersTable.vue?vue&type=script&lang=js"
import style0 from "./WinnersTable.vue?vue&type=style&index=0&id=05a3e49e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a3e49e",
  null
  
)

export default component.exports